import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    FetchProjectPhaseNextIdActionTypes,
    PROJECT_PHASE_NEXT_ID,
    PROJECT_PHASE_NEXT_ID_ERROR,
    PROJECT_PHASE_NEXT_ID_SUCCESS
} from "../../actions/projects/ProjectStagePhaseActions";


export interface ProjectPhaseState {
    nextId: number
    request: RequestState
}

export const initialState = {
    nextId: 0,
    request: getInitialRequestState()
};

export function ProjectPhaseReducer(
    state: ProjectPhaseState = initialState,
    action: FetchProjectPhaseNextIdActionTypes
): ProjectPhaseState {

    switch( action.type ) {
        case PROJECT_PHASE_NEXT_ID:
            return {
                ...state,
                nextId: 0,
                request: startFetchingRequestState()
            };
        case PROJECT_PHASE_NEXT_ID_SUCCESS:
            return {
                ...state,
                nextId: action.payload,
                request: successFetchingRequestState()
            };
        case PROJECT_PHASE_NEXT_ID_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        default: return state;

    }

}